var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGithubIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 31.211,
    viewBox: "0 0 32 31.211",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Octicons-mark-github",
    d: "M16,0a16,16,0,0,0-5.06,31.18c.8.14,1.1-.34,1.1-.76,0-.38-.02-1.64-.02-2.98-4.02.74-5.06-.98-5.38-1.88A5.818,5.818,0,0,0,5,23.3c-.56-.3-1.36-1.04-.02-1.06a3.2,3.2,0,0,1,2.46,1.64A3.42,3.42,0,0,0,12.1,25.2a3.366,3.366,0,0,1,1.02-2.14c-3.56-.4-7.28-1.78-7.28-7.9a6.227,6.227,0,0,1,1.64-4.3,5.749,5.749,0,0,1,.16-4.24s1.34-.42,4.4,1.64a15.085,15.085,0,0,1,8,0c3.06-2.08,4.4-1.64,4.4-1.64a5.749,5.749,0,0,1,.16,4.24,6.191,6.191,0,0,1,1.64,4.3c0,6.14-3.74,7.5-7.3,7.9a3.789,3.789,0,0,1,1.08,2.96c0,2.14-.02,3.86-.02,4.4,0,.42.3.92,1.1.76A16.008,16.008,0,0,0,16,0Z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubIcon);
export default __webpack_public_path__ + "static/media/github-icon.966d08444a590b0bca5dd780ad7ff155.svg";
export { ForwardRef as ReactComponent };